var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Loader } from "sb-resp-ui";
import "blocks/LeagueListPresenter/ui/LeagueListPresenter.less";
import * as CMP from "../components";
import { CouponButtonPosition } from "../../../Typings";
import { getRenderParams } from "../helper";
let LeagueListPresenter = class LeagueListPresenter extends React.Component {
    constructor(props) {
        super(props);
        // setup dictionary
        this.dict = props.dict;
        this.refEl = React.createRef();
        // setup data provider
        this.state = {
            dataProvider: props.dataProvider
        };
    }
    renderLeagues(options) {
        return (React.createElement("div", { className: options.className, ref: this.refEl },
            this.renderHeader(options),
            this.renderContent(options),
            options.shouldShowCoupononBottom && this.renderCouponButton(options.sportId),
            this.renderShowAllBtn(options.hasTopLeaguesOnly)));
    }
    renderHeader(options) {
        return options.view.length ? (React.createElement(CMP.SportHeader, { label: this.dict[options.headerPhrase] }, this.state.dataProvider.options.cms.isCouponCreationEnabled &&
            this.state.dataProvider.selectedLeagues.length ?
            React.createElement(CMP.CreateCouponBtn, { sportId: options.sportId, onClick: this.state.dataProvider.openCouponTranspiler, label: this.dict.CreateCoupon, count: this.state.dataProvider.selectedLeagues.length, parentRef: this.refEl, cuponPosition: this.props.dataProvider.options.cms.couponButtonPosition, wrapEl: this.props.dataProvider.options.navHandler.centerPanelHolder.element, tabletTopOffSet: this.props.dataProvider.options.navHandler.topPanelsHolder.element.getBoundingClientRect().height, deviceType: this.props.dataProvider.deviceDetect }) : "")) : "";
    }
    renderContent(options) {
        return options.view.length ? (React.createElement("div", { className: "rj-league-list__content", "data-uat": "div-league-list-content" }, options.view)) : "";
    }
    renderCouponButton(sportId) {
        return (this.props.dataProvider.options.cms.couponButtonPosition === CouponButtonPosition.Static
            && this.state.dataProvider.showBottomButton &&
            React.createElement(CMP.CreateCouponBtn, { sportId: sportId, onClick: this.state.dataProvider.openCouponTranspiler, label: this.dict.CreateCoupon, count: this.state.dataProvider.selectedLeagues.length, parentRef: this.refEl, cuponPosition: this.props.dataProvider.options.cms.couponButtonPosition, wrapEl: this.props.dataProvider.options.navHandler.centerPanelHolder.element, tabletTopOffSet: this.props.dataProvider.options.navHandler.topPanelsHolder.element.getBoundingClientRect().height, deviceType: this.props.dataProvider.deviceDetect }));
    }
    renderShowAllBtn(hasTopLeagues) {
        return !hasTopLeagues && this.state.dataProvider.leagues.length > this.state.dataProvider.numberOfAllLeaguesShownByDefault &&
            React.createElement(CMP.ShowAllBtn, { onClick: this.state.dataProvider.showAllButtonHandler, expanded: this.state.dataProvider.showAllButton.expanded, label: this.state.dataProvider.showAllButton.label });
    }
    getLeagueItem(league) {
        return React.createElement(CMP.LeagueItem, { key: league.isTopLeague ? `LeagueItem-${league.id}-TopLeague` : `LeagueItem-${league.id}`, league: league, showCheckbox: this.state.dataProvider.options.cms.isCouponCreationEnabled, toggleSelectedLeague: this.state.dataProvider.toggleSelectedLeague.bind(this.state, league.id), openLeagueTranspiler: this.state.dataProvider.openLeagueTranspiler, tooltipMessage: this.dict.SelectedLeaguesLimitReached, showTooltip: this.state.dataProvider.selectedLeaguesLimitReached, selectedLeagueId: this.state.dataProvider.currentlySelectedLeague, dict: this.dict });
    }
    renderView(view, topLeagues, allLeagues) {
        let isTopLeaguesOnly = this.state.dataProvider.leagues.every(league => league.isTopLeague === true);
        return (isTopLeaguesOnly && view.topLeagues.length
            ? (React.createElement(React.Fragment, null, topLeagues))
            : (this.state.dataProvider.options.cms.showTopLeaguesList && view.topLeagues.length
                ? (React.createElement(React.Fragment, null,
                    React.createElement(React.Fragment, null, topLeagues),
                    React.createElement(React.Fragment, null, allLeagues)))
                : allLeagues));
    }
    renderLoader() {
        return React.createElement("div", { className: "rj-league-list", "data-uat": "div-league-list-loader" },
            React.createElement(Loader, null));
    }
    render() {
        /*
            How to use the dataProvider can be seen in an example here:
            https://confluence.sbtech.com/display/FR/React+LeagueListPresenter+Example
        */
        const view = {
            allLeagues: [],
            topLeagues: []
        };
        this.state.dataProvider.onlyShownTopLeagues().forEach(l => view.topLeagues.push(this.getLeagueItem(l)));
        this.state.dataProvider.onlyShowLeagues().forEach(league => view.allLeagues.push(this.getLeagueItem(league)));
        const sportId = this.state.dataProvider.sportId;
        const allLeaguesListClass = "rj-league-list";
        const leagueListClass = "rj-league-list__top-leagues";
        const topLeagues = this.renderLeagues(getRenderParams(leagueListClass, sportId, this.state.dataProvider.options.cms.topLeaguesPhrase, view.topLeagues, true, false));
        const allLeagues = this.renderLeagues(getRenderParams(allLeaguesListClass, sportId, this.state.dataProvider.options.cms.headerPhrase || this.state.dataProvider.options.cms.allLeaguesPhrase, view.allLeagues, false, true));
        return (this.state.dataProvider.isDataLoaded ?
            this.renderView(view, topLeagues, allLeagues) :
            this.renderLoader());
    }
};
LeagueListPresenter = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], LeagueListPresenter);
export { LeagueListPresenter };
//# sourceMappingURL=LeagueListPresenter.js.map